const PROMISE_STATUS = {
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected',
    PENDING: 'pending'
};
export function wrapPromise(promiseFn) {
    let _status, _resolveData, _rejectError;
    const _queue = [];
    const _executeResolve = resolve => {
        _status = PROMISE_STATUS.FULFILLED;
        while (_queue.length) {
            _queue.pop().resolve(_resolveData);
        }
        resolve(_resolveData);
    };
    const _executeReject = reject => {
        _status = PROMISE_STATUS.REJECTED;
        while (_queue.length) {
            _queue.pop().reject(_rejectError);
        }
        reject(_rejectError);
    };
    return function() {
        return new Promise((resolve, reject) => {
            if (_status === PROMISE_STATUS.FULFILLED) {
                _executeResolve(resolve);
            } else if (_status === PROMISE_STATUS.PENDING) {
                _queue.push({
                    resolve,
                    reject
                });
            } else {
                _status = PROMISE_STATUS.PENDING;
                promiseFn()
                    .then(data => {
                        _resolveData = data;
                        _executeResolve(resolve);
                    })
                    .catch(error => {
                        _rejectError = error;
                        _executeReject(reject);
                    });
            }
        });
    };
}
